<form [formGroup]="labelForm" (ngSubmit)="isFormSubmitted = true;onSaveClick()">
    <div class="modla-content">
        <div class="modal-header">
            <h4 class="modal-title">Print Label</h4>
            <button type="button" class="btn-close" aria-label="Close"
                (click)="activeModal.close('Cross click')"></button>
        </div>
        <div class="modal-body">
            <div class="alert alert-warning alert-dismissible fade show" role="alert">
                <i class="mdi mdi-alert-outline me-2"></i>
                Ensure that the maximum range between 'From' and 'To' piece numbers does not exceed to 100.
            </div>
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12 col-sm-12">
                            <label for="bagno" class="form-label">Piece No.</label>
                            <div class="input-group mb-2">
                                <span class="input-group-text group-label-sm">From <span
                                        class="mandatory">*</span></span>
                                <div class="input-group-item">
                                    <input type="number" class="form-control form-control-sm"
                                        formControlName="txtFromNo" (change)="validateRange()"
                                        [ngClass]="{'is-invalid':(isFormSubmitted ||labelForm.get('txtFromNo').touched) && labelForm.get('txtFromNo').errors}">
                                    <div *ngIf="(isFormSubmitted ||labelForm.get('txtFromNo').touched) && labelForm.get('txtFromNo').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="labelForm.get('txtFromNo').errors.required">From No is
                                            Required</span>
                                    </div>
                                </div>
                                <span class="input-group-text group-label-sm">To </span>
                                <div class="input-group-item">
                                    <input type="number" class="form-control form-control-sm" formControlName="txtToNo"
                                        (change)="validateRange()">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <!-- <button type="button" class="btn btn-outline-dark" (click)="resetForm();">Reset</button> -->
        <button type="submit" class="btn btn-outline-dark">Print</button>
    </div>
</form>